import React from "react";
import ItemTime from "../ItemTime.js";
import ActItemSubscript from "../../listTypes/act/ActItemSubscript";

export default function Appointment({
  details,
  currentTimeInMinutes,
  isToday,
  listType,
  dateHelper,
}) {
  return (
    <div className="item Appointment">
      <ItemTime
        prettyTime={details.time}
        currentTimeInMinutes={currentTimeInMinutes}
        itemTimeInMinutes={details.time_in_minutes}
        isToday={isToday}
      />
      <div className="item-stacked-text">
        <div className="appointment-name bold-item-txtstyl">{details.name}</div>
        {listType === "Act" && (
          <ActItemSubscript details={details} dateHelper={dateHelper} />
        )}
      </div>
    </div>
  );
}
